































































import { Component, Vue } from 'vue-property-decorator'
import { ActionTypes } from '@/store/action-types'

@Component
export default class FavoriteCourses extends Vue {
  public toggleFavoriteCourse(product: { id: any }): void {
    this.$store.dispatch(ActionTypes.STORE_FAVORITE_COURSES, product)
  }
}
